import { render } from "./LanguageModal.vue?vue&type=template&id=1ab66f23&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"

import "./LanguageModal.vue?vue&type=style&index=0&id=1ab66f23&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab66f23"]])

export default __exports__